import moment from 'moment';

import { PatientInfoFieldDisplay } from './PatientLeftRail';
import { PatientLeftRailQuery } from './PatientLeftRail.gql.types';

type VisitItem = NonNullable<
    NonNullable<PatientLeftRailQuery['patient']>['lastVisit']
>['items'][number];

const visitServiceNames = (visit: VisitItem): string =>
    (visit.clinicianAppointments ?? [])
        .flatMap((appointment) => appointment.services)
        .map((service) => service.name)
        .join(', ');

const visitAssignees = (visit: VisitItem): string =>
    (visit.clinicianAppointments ?? [])
        .map((appointment) => appointment.clinician?.fullName)
        .filter((name): name is string => Boolean(name))
        .join(', ');

const VisitRow = ({ label, visit }: { label: string; visit: VisitItem | undefined }) => {
    if (!visit) {
        // Undefined value makes the shared row render the left-rail "None" label.
        return <PatientInfoFieldDisplay label={label} value={undefined} />;
    }

    const services = visitServiceNames(visit);
    const assignees = visitAssignees(visit);
    return (
        <PatientInfoFieldDisplay
            label={label}
            value={
                <>
                    {moment(visit.effectiveDate).format('MMM D, YYYY')}
                    {services && (
                        <>
                            <br />
                            {services}
                        </>
                    )}
                    {assignees && (
                        <>
                            <br />
                            {assignees}
                        </>
                    )}
                </>
            }
        />
    );
};

export const PatientLeftRailVisitsSection = ({
    lastVisit,
    nextVisit,
}: {
    lastVisit: VisitItem | undefined;
    nextVisit: VisitItem | undefined;
}) => (
    <>
        <VisitRow label='Last Visit' visit={lastVisit} />
        <VisitRow label='Next Visit' visit={nextVisit} />
    </>
);
